import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
    root: {

    },
    textField: {
        width: '5em !important',
        display: 'inline-block',
        margin: '2px'
    },
    input: {
        fontSize: '3em',
        textAlign: 'center',
        caretColor: 'transparent'
    },
    formControl: {

    }
}))
